import React from "react";

const Freeservicepopup = ({ popupData = [], onClose }) => {
    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-xl shadow-xl w-[90%] md:w-[70%] lg:w-[60%] max-h-[80vh] overflow-y-auto p-6 relative"
                onClick={(e) => e.stopPropagation()} // prevent closing on inside click
            >
                <h2 className="text-xl font-semibold text-[#267CB8] mb-4">
                    Free Service Details
                </h2>

                <table className="min-w-full border border-gray-300 rounded-lg">
                    <thead className="bg-[#267CB8] text-white sticky top-0">
                        <tr>
                            <th className="px-4 py-2 border">Sr No</th>
                            <th className="px-4 py-2 border">Service Type</th>
                            <th className="px-4 py-2 border">Reg No</th>
                            <th className="px-4 py-2 border">Chassis No</th>
                            <th className="px-4 py-2 border">AMC Number</th>
                            <th className="px-4 py-2 border">AMC Due Date</th>
                        </tr>
                    </thead>

                    <tbody>
                        {popupData.length > 0 ? (
                            popupData.map((row, i) => (
                                <tr
                                    key={i}
                                    className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                                >
                                    {/* Sr No */}
                                    <td className="px-4 py-2 border">{row.sr_no || i + 1}</td>

                                    {/* Service Type */}
                                    <td className="px-4 py-2 border">
                                        {row.NEXT_SERVICE_TYPE_AGG || "-"}
                                    </td>

                                    {/* Registration No */}
                                    <td className="px-4 py-2 border">
                                        {row.VEHICLE_REGISTRATION_NUMBER || "-"}
                                    </td>

                                    {/* Chassis No */}
                                    <td className="px-4 py-2 border">
                                        {row.ASSET_NUMBER || "-"}
                                    </td>

                                    {/* AMC Number → not in API so "-" */}
                                    <td className="px-4 py-2 border">-</td>

                                    {/* AMC Due Date */}
                                    <td className="px-4 py-2 border">
                                        {row.NEXT_SERVICE_DATE || "-"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan="6"
                                    className="text-center text-gray-500 py-4 border"
                                >
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* Cancel Button */}
                <div className="mt-6 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-5 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-lg transition"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Freeservicepopup;
